import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";

const ServerErrorPage = ({ onRetry }) => {
  const navigate = useNavigate();

  return (
    <div style={{ textAlign: "center", marginTop: "100px" }}>
      <h2>Internal Server Error</h2>

      <Button
        variant="contained"
        color="primary"
        onClick={onRetry}
        style={{ marginRight: "10px" }}
      >
        Refresh Page
      </Button>

      {/* 🏠 Go Home button */}
      <Button
        variant="outlined"
        onClick={() => navigate("/")}
      >
        Go to Home
      </Button>
    </div>
  );
};

export default ServerErrorPage;